import React from "react";
import { useQuery } from "@apollo/client";

import { GET_WORK_SESSIONS } from "graphql/query/attendance-gql";
import { Loader, NoData } from "components/request-result";
import Localize from "components/service/localize";
import { OptimizedList } from "components/service";
import AttendanceTimeRecordItem from "./attendance-time-record-item";


const PER_PAGE = 30;

const AttendanceTimeRecordsList = ({ eeId, moment }) => {
    const { data, loading, error, fetchMore } = useQuery(GET_WORK_SESSIONS, {
        variables: {
            where: {
                column: "EE_ID",
                operator: "EQ",
                value: eeId
            },
            orderBy: [
                {
                    column: "CHECK_IN_AT",
                    order: "DESC"
                }
            ],
            first: PER_PAGE
        },
        skip: !eeId,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    });

    const {
        edges = [],
        pageInfo = {}
    } = data?.workSessionsCursor || {};

    if (!eeId) {
        return (
            <NoData
                className="block"
                text={ {
                    after: <Localize>ATTENDANCE.SelectExhibitionFirst_Text</Localize>
                } }
                icon="job"
            />
        );
    }

    if (error && !edges.length) {
        return (
            <NoData
                className="block"
                text={ {
                    after: <Localize>ATTENDANCE.Error_TimeRecordsLoad_Text</Localize>
                } }
                icon="job"
            />
        );
    }

    return (
        <>
            {!edges.length && !loading && (
                <NoData
                    className="block"
                    text={ {
                        after: <Localize>ATTENDANCE.TimeRecords_Empty</Localize>
                    } }
                    icon="job"
                />
            )}
            {!!edges.length && (
                <OptimizedList
                    listClass="attendance-time-records"
                    itemClass="attendance-time-record-wrap"
                    listItems={ edges }
                    pageInfo={ pageInfo }
                    fetchMore={ fetchMore }
                    perPage={ PER_PAGE }
                    model="workSessionsCursor"
                >
                    <AttendanceTimeRecordItem moment={ moment } />
                </OptimizedList>
            )}
            {loading && <Loader type="block" tipText="" />}
        </>
    );
};

export default AttendanceTimeRecordsList;
